module.exports = __webpack_public_path__ + "img/award.f3897cc4.jpg";